/* eslint-disable react/no-array-index-key */
/* eslint-disable no-shadow */
import React, {useState} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import * as Yup from 'yup';
import {Formik} from 'formik';
import {
    Box,
    Button,
    Chip,
    FormHelperText,
    IconButton,
    SvgIcon,
    TextField,
    Typography,
    CardHeader,
    Divider,
    CardContent,
    CircularProgress,
    Grid,
    Checkbox,
    Link,
    Card,
    Avatar,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import {Plus as PlusIcon, Star as StarIcon} from 'react-feather';
import { Alert } from '@mui/material';
import {
    GoogleReCaptchaProvider,
    GoogleReCaptcha,
    useGoogleReCaptcha
} from 'react-google-recaptcha-v3';
import wait from "../../../utils/wait";
import {Link as RouterLink} from "react-router-dom";

const useStyles = makeStyles((theme) => ({
    root: {},
    addTab: {
        marginLeft: theme.spacing(2)
    }
}));

const userTypeOptions = [{name: 'SCHOOL', description: 'School'},{name: 'HOME_SCHOOL', description: 'Home Schooler/Tutor'},{name: 'BOOKSELLER', description: 'Bookseller'}];

function Uploader({enquiryType,
                           enquiry,
                            onBack,
                            onNext,
                            onChangeEnquiry
                        }) {
    const classes = useStyles();
    const [isAlertVisible, setAlertVisible] = useState(false);

    return (
        <Formik
            initialValues={enquiry}
            validationSchema={Yup.object().shape({})}
            onSubmit={(values, {
                resetForm,
                setErrors,
                setStatus,
                setSubmitting
            }) => {
                setStatus({success: true});
                setSubmitting(false);
                onChangeEnquiry(values);
                if (onNext) {
                    onNext();
                }
            }}
        >
            {({
                  errors,
                  handleBlur,
                  handleChange,
                  handleSubmit,
                  isSubmitting,
                  setFieldValue,
                  setFieldTouched,
                  touched,
                  values
              }) => (
                <Card>
                    <CardHeader title={enquiryType.title} titleTypographyProps={{variant: 'h5', color: 'secondary'}}/>
                    <Divider/>
                    <CardContent>
                        {isAlertVisible && (
                            <Box mb={3}>
                                <Alert
                                    onClose={() => setAlertVisible(false)}
                                    severity="info"
                                >
                                    This is an info alert - check it out!
                                </Alert>
                            </Box>
                        )}
                        {isSubmitting ? (
                            <Box
                                display="flex"
                                justifyContent="center"
                                my={5}
                            >
                                <CircularProgress/>
                            </Box>
                        ) : (
                            <form onSubmit={handleSubmit}>
                                <Box mt={2}>
                                    <Typography
                                        variant="subtitle1"
                                        color="textSecondary"
                                    >
                                        Are you from a school, bookseller or homeschool/tutor?
                                    </Typography>
                                </Box>
                                <Box
                                    mt={2}
                                    display="flex"
                                >
                                    <TextField
                                        label="Select school, bookseller or homeschool/tutor?"
                                        name="importUserType"
                                        onChange={handleChange}
                                        select
                                        SelectProps={{ native: true }}
                                        value={values.importUserType}
                                        variant="outlined"
                                        style={{width: 300}}
                                    >
                                        {userTypeOptions.map((userTypeOption) => (
                                            <option
                                                key={userTypeOption.name}
                                                value={userTypeOption.name}
                                            >
                                                {userTypeOption.description}
                                            </option>
                                        ))}
                                    </TextField>
                                </Box>
                                <Box
                                    mt={6}
                                    display="flex"
                                >
                                    {onBack && (
                                        <Button
                                            onClick={onBack}
                                            size="large"
                                            color="secondary"
                                            variant="contained"
                                        >
                                            Previous
                                        </Button>
                                    )}
                                    <Box flexGrow={1}/>
                                    <Button
                                        color="secondary"
                                        disabled={isSubmitting}
                                        type="submit"
                                        variant="contained"
                                        size="large"
                                    >
                                        Next
                                    </Button>
                                </Box>
                            </form>
                        )}
                    </CardContent>
                </Card>
            )}
        </Formik>
    );
}

Uploader.propTypes = {
    enquiryType: PropTypes.object,
    enquiry: PropTypes.object,
    onNext: PropTypes.func,
    onBack: PropTypes.func,
    onChangeEnquiry: PropTypes.func
};

export default Uploader;
